import { CommonModule } from "@angular/common";
import { Component, computed, HostBinding, model, output } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: 'notification-toast',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.sass'],
    imports: [CommonModule, TranslatePipe]
})
export class NotificationComponent {

    summary = model.required<string>();;
    detail = model<string>('');
    icon = model<string>('');
    severity = model<'info' | 'success' | 'warn' | 'error'>('info');
    sticky = model<boolean>(false);
    lifetime = model<number | undefined>();
    data = model<Object | undefined>();
    closed = output<void>();
    onClick = model<() => void>();

    @HostBinding('class.has-click')
    get clickable() { return !!this.hasClick(); }

    hasClick = computed(() => !!this.onClick());

    timeoutId: any;

    ngOnInit() {
        if (!this.sticky()) {
            this.timeoutId = setTimeout(() => this.close(), this.lifetime() ?? 4000);
        }
    }

    click() {
        const action = this.onClick();
        if (action) action();
        this.close();
    }
    
    close(event: Event | null = null) {
        if (this.timeoutId) clearTimeout(this.timeoutId);
        if (event) event.stopPropagation();
        this.closed.emit();
    }

}